import Vue from 'vue'
import moment from 'moment'
require('moment/locale/th')
Vue.use(require('vue-moment'), {
  moment
})
